import FetchService from './base.fetch';
import Cookie from './base.cookie';
import CONSTANT from 'src/constant';
import OSS from 'ali-oss';
import { getInternational } from '../../util/env';

const getUtoken = () => Cookie.get(CONSTANT.USER_ACCESS_TOKEN_KEY);
const TIMEOUT = 30000;
const PART_SIZE = 100 * 1024;
const RETURY_MAX = 3;

const getEmptyState = () => {
    return Object.assign({}, {
        client: null,
        checkpoint: null,
        retryCount: 0,
        name: null,
        uploadId: null
    });
};

class ProjectOss {
    constructor () {
        this.domain = FetchService.domainconfig.cloud[getInternational()];
        const tokenConfig = {
            // 获取作品上传令牌
            uploadToken: {
                method: 'get',
                url: 'cloud/token/upload'
            },
            // 获取封面上传令牌
            uploadImgToken: {
                method: 'get',
                url: 'cloud/token/coverupload'
            },
        };
        FetchService.configToRequestAction.call(this, tokenConfig, FetchService);
        this.coverImg = getEmptyState();
        this.project = getEmptyState();
    }

    getProjectToken () {
        return this.uploadToken({
            '_HEADER_': { 'utoken': getUtoken(), 'pid': 1 }
        });
    }

    getCoverImgToken () {
        return this.uploadImgToken({
            '_HEADER_': { 'utoken': getUtoken(), 'pid': 2 }
        });
    }

    async multipartUploadCoverImg (file, progress) {
        this.coverImg = getEmptyState();
        let tokenRes = null;
        try {
            tokenRes = await this.getCoverImgToken();
        } catch (err) {
            throw(err);
        }
        if (tokenRes) {
            const option = {
                'Content-Encoding': 'gzip',
                timeout: TIMEOUT,
                partSize: PART_SIZE,
                progress: async (percentage, checkpoint) => {
                    if (checkpoint) {
                        this.coverImg.checkpoint = checkpoint;
                        this.coverImg.name = checkpoint.name;
                        this.coverImg.uploadId = checkpoint.uploadId;
                    }
                    if (typeof progress === 'function') {
                        progress(percentage * 100);
                    }
                }
            };
            const { commitId, ...ossOptions } = tokenRes;
            this.coverImg.client = new OSS(ossOptions);
            this.coverImg.name = commitId;
            let uploadError = null;
            try {
                const uploadRes = await this.multipartUpload(this.coverImg.client, commitId, file, option);
                if (uploadRes && uploadRes.res && uploadRes.res.status === 200) {
                    return uploadRes.res.requestUrls[0];
                }
            } catch (err) {
                uploadError = err;
            }
            this.abortAll();
            throw(uploadError);
        }
    }

    async multipartUploadProject (file, progress, info) {
        this.project = getEmptyState();
        let tokenRes = null;
        try {
            tokenRes = await this.getProjectToken();
        } catch (err) {
            throw(err);
        }
        if (tokenRes) {
            const { commitId, callbackUrl, ...ossOptions } = tokenRes;
            const callbackBody = 'coverImage=${x:coverImage}&utoken=${x:utoken}&pid=${x:pid}&fileName=${x:fileName}&fsize=${size}&bucket=${bucket}&object=${object}&etag=${etag}&size=${size}&commitId=${x:commitId}&handle=${x:handle}&projectName=${x:projectName}&projectId=${x:projectId}&createdAt=${x:createdAt}';
            const { projectId, projectName, localName, createdAt, coverImage, isSelfProject } = info;
            const callback = {
                url: callbackUrl,
                body: callbackBody,
                customValue: {
                    utoken: getUtoken(),
                    pid: '1',
                    commitId: commitId,
                    fileName: localName,
                    handle: !isSelfProject ? 'adapt' : Number(projectId) > 0 ? 'edit' : 'create',
                    projectName: projectName,
                    projectId: String(projectId),
                    coverImage: coverImage || 'null',
                    createdAt: String(createdAt)
                }
            };
            console.log('callback: ', callback);
            const option = {
                'Content-Encoding': 'gzip',
                timeout: TIMEOUT,
                partSize: PART_SIZE,
                callback,
                progress: async (percentage, checkpoint) => {
                    if (checkpoint) {
                        this.project.checkpoint = checkpoint;
                        this.project.name = checkpoint.name;
                        this.project.uploadId = checkpoint.uploadId;
                    }
                    if (typeof progress === 'function') {
                        progress(percentage * 100);
                    }
                }
            };
            this.project.client = new OSS(ossOptions);
            this.project.name = commitId;
            let uploadError = null;
            try {
                const uploadRes = await this.multipartUpload(this.project.client, commitId, file, option);
                if (uploadRes && uploadRes.data && uploadRes.data.code === 0) {
                    return {
                        projectId: uploadRes.data.data.projectId || projectId,
                        commitId: commitId
                    };
                }
            } catch (err) {
                uploadError = err;
            }
            this.abortAll();
            throw(uploadError);
        }
    }

    multipartUpload (client, name, file, option) {
        if (!client) return;
        let obj = {};
        if (client === this.coverImg.client) {
            obj = this.coverImg;
        } else if (client === this.project.client) {
            obj = this.project;
        }
        if (obj.checkpoint) {
            option.checkpoint = obj.checkpoint;
        }

        return client.multipartUpload(name, file, option)
            .then(res => {
                return res;
            })
            .catch(err => {
                if (client.isCancel()) {
                    throw(err);
                } else if (err && (err.code === 'ConnectionTimeoutError' || err.name.toLowerCase().indexOf('connectiontimeout') !== -1)) {
                    if (obj.retryCount < RETURY_MAX) {
                        obj.retryCount ++;
                        this.multipartUpload(client, name, file, option);
                    }
                }
            });
    }

    abortMultipartUpload ({client, name, uploadId}) {
        if (!client) return;
        client.cancel();
        try {
            if (name && uploadId) {
                return client.abortMultipartUpload(name, uploadId);
            }
            if (name) {
                return client.delete(name);
            }
        } catch (err) {
            console.warn(err);
        }
    }

    abortAll () {
        this.abortMultipartUpload(this.coverImg);
        this.abortMultipartUpload(this.project);
    }
}

export default ProjectOss;